<template>
  <div v-if="visible" class="transaction-success-overlay" @click="handleOverlayClick">
    <div class="transaction-success-dialog" @click.stop>
      <!-- 成功图标 -->
      <div class="success-icon">
        <div class="success-circle">
          <svg viewBox="0 0 24 24" class="check-icon">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/>
          </svg>
        </div>
      </div>

      <!-- 标题 -->
      <h2 class="success-title">交易成功</h2>

      <!-- 订单信息 -->
      <div class="order-info">
        <div class="info-item">
          <span class="info-label">订单号：</span>
          <span class="info-value">{{ orderInfo.orderNo }}</span>
        </div>
        <div class="info-item">
          <span class="info-label">收款金额：</span>
          <span class="info-value amount">¥{{ orderInfo.amount.toFixed(2) }}</span>
        </div>
      </div>

      <!-- 按钮组 -->
      <div class="dialog-actions">
        <button class="action-btn confirm-btn" @click="handleConfirm">
          确认
        </button>
        <button class="action-btn print-btn" @click="handlePrint">
          打印小票
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TransactionSuccessDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderInfo: {
      type: Object,
      required: true,
      default: () => ({
        orderNo: '',
        amount: 0.00
      })
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm')
    },
    handlePrint() {
      this.$emit('print')
    },
    handleOverlayClick() {
      // 点击遮罩不关闭，必须点击按钮
    }
  }
}
</script>

<style scoped>
.transaction-success-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.transaction-success-dialog {
  background-color: white;
  border-radius: 16px;
  width: 480px;
  max-width: 90vw;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.success-icon {
  margin-bottom: 24px;
}

.success-circle {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #52c41a, #73d13d);
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 20px rgba(82, 196, 26, 0.3);
  animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}

.check-icon {
  width: 40px;
  height: 40px;
  fill: white;
}

.success-title {
  margin: 0 0 32px 0;
  font-size: 28px;
  font-weight: bold;
  color: #1a1a1a;
  letter-spacing: 1px;
}

.order-info {
  background-color: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 32px;
  border: 1px solid #e9ecef;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
}

.info-item:last-child {
  margin-bottom: 0;
}

.info-label {
  color: #666;
  font-weight: 500;
}

.info-value {
  color: #333;
  font-weight: 600;
  font-family: 'Monaco', 'Menlo', monospace;
}

.info-value.amount {
  color: #52c41a;
  font-size: 20px;
  font-weight: bold;
}

.dialog-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.action-btn {
  min-width: 120px;
  height: 48px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.action-btn:before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.action-btn:active:before {
  width: 300px;
  height: 300px;
}

.confirm-btn {
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: white;
  box-shadow: 0 4px 15px rgba(24, 144, 255, 0.3);
}

.confirm-btn:hover {
  background: linear-gradient(135deg, #40a9ff, #69c0ff);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(24, 144, 255, 0.4);
}

.print-btn {
  background: linear-gradient(135deg, #722ed1, #9254de);
  color: white;
  box-shadow: 0 4px 15px rgba(114, 46, 209, 0.3);
}

.print-btn:hover {
  background: linear-gradient(135deg, #9254de, #b37feb);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(114, 46, 209, 0.4);
}

/* 响应式设计 */
@media (max-width: 576px) {
  .transaction-success-dialog {
    width: 95vw;
    padding: 30px 20px;
  }

  .success-title {
    font-size: 24px;
  }

  .info-item {
    font-size: 14px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .dialog-actions {
    flex-direction: column;
  }

  .action-btn {
    width: 100%;
  }
}
</style>